import { useState, useEffect } from "react"
import SectionForm, { useFormContext } from "../SectionForm"
import { useBienContext } from "../BienContext"
import { Input} from "@/components/ui"

const fields = [
  // Partie 1
  {name: "surface_carrez", label: "Surface carrez"}, 
  {name: "surface_sol", label: "Surface sol"},
  {name: "surface_terrain", label: "Surface terrain"},
  // Partie 2
  {name: "surface_jardin", label: "Surface jardin"}, 
  {name: "orientation", label: "Orientation"},
  {name: "constructible", label: "Constructible"},
  // Partie 3
  {name: "georisques", label: "Géorisques"},
  {name: "vis_a_vis", label: "Vis à vis"},
]

const FormContent = ({item}) => {
  const { control, setValue, getValues } = useFormContext()
  const [hectares, setHectares] = useState(0)
  const [ares, setAres] = useState(0)
  const [centiares, setCentiares] = useState(0)

  useEffect(() => {
    if(getValues('surface_terrain')) {
      const surfaceTerrain = parseInt(getValues('surface_terrain'))
      
      // Convertir la surface en m² en hectares, ares et centiares
      // 1 hectare = 10000 m²
      const ha = Math.floor(surfaceTerrain / 10000)
      
      // 1 are = 100 m²
      const a = Math.floor((surfaceTerrain % 10000) / 100)
      
      // 1 centiare = 1 m²
      const ca = surfaceTerrain % 100
      
      // Mettre à jour les états
      setHectares(ha)
      setAres(a)
      setCentiares(ca)
    }
  }, [getValues])

  // Calcul de la surface terrain en m² à partir des hectares, ares et centiares
  useEffect(() => {
    // 1 hectare = 10000 m², 1 are = 100 m², 1 centiare = 1 m²
    const surfaceTerrain = (hectares * 10000) + (ares * 100) + centiares
    setValue('surface_terrain', surfaceTerrain)
  }, [hectares, ares, centiares, setValue])

  return (
    <>
      <div className="flex flex-col items-start gap-4">
        <Input.Surface 
          name={fields[0].name}
          control={control}
          label={fields[0].label}
        />
        <Input.File control={control}
          name="surface_carrez_file"
          label="Attestation Carrez"
          defaultValue={item?.surface_carrez_file?.filename || '' }
          inputProps={{accept: ".pdf"}}
          canDelete={true}
        />
        <Input.Surface 
          name={fields[1].name}
          control={control}
          label={fields[1].label}
        />
        <div className="w-full">
          <label className="input w-full">
            <span className="label">Surface terrain</span>
            <div className="flex gap-2 w-full">
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  value={hectares}
                  onChange={(e) => setHectares(parseInt(e.target.value) || 0)}
                  className="input w-20"
                />
                <span className="label ml-1">ha</span>
              </div>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="99"
                  value={ares}
                  onChange={(e) => setAres(parseInt(e.target.value) || 0)}
                  className="input w-20"
                />
                <span className="label ml-1">a</span>
              </div>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="99"
                  value={centiares}
                  onChange={(e) => setCentiares(parseInt(e.target.value) || 0)}
                  className="input w-20"
                />
                <span className="label ml-1">ca</span>
              </div>
            </div>
          </label>
        </div>
      </div>
      <div className="flex flex-col items-start gap-4">             
        {fields.slice(3,6).map( ({name, label}, index) => (
          name === 'surface_jardin' ?
            <Input.Surface key={index}
              name={name}
              control={control}
              label={label}
            /> : 
            <Input.Text key={index}
              name={name}
              control={control}
              label={label}
            />
          ))
        }
      </div>
      <div className="flex flex-col items-center gap-4">                
        {fields.slice(6).map(
          ({name, label}, index) => (
            <Input.Text key={index}
              name={name}
              control={control}
              label={label}
            />
          ))
        }
      </div>
    </>
  )
}

export default ({ title = "", onClose = () => {}, onSuccess = () => {} }) => {
  const { bien } = useBienContext()

  return <SectionForm
    title={title}
    onClose={onClose}
    onSuccess={onSuccess}
    fields={[
      ...fields.map( f => f.name),
      "surface_carrez_file"
    ]}
  >
    <FormContent item={bien} />
  </SectionForm>
}